module.exports = __webpack_public_path__ + "img/househould-visit.a730efb7.svg";